import { FirstPersonCamera, ThirdPersonCamera } from "@objects/cameras";
class CameraManager {
    cameras;
    selected;
    static instance;
    /**
     * Class managing the cameras that can be used in the game.
     * @param parent A parent that the camera should be associated to.
     */
    constructor(parent) {
        this.cameras = {
            firstPerson: FirstPersonCamera.getInstance(parent),
            thirdPerson: ThirdPersonCamera.getInstance(parent),
        };
        this.selected = "firstPerson";
    }
    /**
     * Switch between first-person and third-person cameras.
     */
    switch() {
        if (this.selected === "firstPerson") {
            this.selected = "thirdPerson";
        }
        else {
            this.selected = "firstPerson";
        }
        this.getSelected.updateResolution();
    }
    addParent(parent) {
        parent.add(this.cameras.firstPerson.getCamera);
        parent.add(this.cameras.thirdPerson.getCamera);
    }
    /**
     * Update the resolution of the currently selected camera.
     */
    updateResolution() {
        this.getSelected.updateResolution();
    }
    get getSelected() {
        return this.cameras[this.selected];
    }
    static getInstance(parent) {
        if (!CameraManager.instance)
            CameraManager.instance = new CameraManager(parent);
        return CameraManager.instance;
    }
}
export default CameraManager;
